<template>
  <div class="campaign-event-list-item" @click="selectEvent">
    <div
      class="campaign-event-list-item--number border-top border-bottom bg-gradient"
      :class="{
        'bg-danger': selected,
        'bg-secondary': !selected,
      }"
    >
      <div class="fs-2 d-block text-left fw-bold text-white px-2 py-1">
        {{
          currentCampaign && currentCampaign.campaign_number && currentCampaign.campaign_number.label
            ? currentCampaign.campaign_number.label
            : prettyPhoneNumber(currentCampaign.campaign_number)
        }}
      </div>
    </div>
    <div
      class="campaign-event-list-item--content px-2 py-1"
      :class="{ 'event-selected': selected }"
    >
      <div class="campaign-event-list-item--content-event">
        <div class="d-flex align-items-center justify-content-center">
          <b-icon icon="people-fill" scale="2" title="Campaign Event Item" />
        </div>
        <div class="fs-2 text-truncate fw-normal text-muted">
          {{ this.listItem.event_name }}
        </div>
        <div class="fs-2 fw-normal text-muted" style="margin-left: auto;">
          {{ eventSubscriberMessage }}
        </div>
      </div>
      <div
        class="campaign-event-list-item--content-timestamp fs-2 fw-normal text-muted font-italic text-nowrap text-right"
        style="position: relative"
      >
        {{ formattedTimestamp }}
      </div>
    </div>
    <div :class="`campaign-event-list-item--message ngx-0 px-2 pb-2 ${selected ? 'event-selected' : ''}`">
      <div class="d-block text-truncate fw-normal text-left">
        {{ this.listItem.event_message }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment';
import { mapGetters } from 'vuex';
import formatter from "@/mixins/formatter";

export default {
  name: "CampaignEventListItem",
  mixins: [formatter],
  props: {
    listItem: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("campaigns", ["currentCampaign"]),
    eventSubscriberMessage() {
      return `${this.formatNumber(Number(this.listItem.total_subscribers))} Subscribers`;
    },
    formattedTimestamp() {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const updatedAt = moment.utc(this.listItem.updated_at).tz(tz);
      return moment(updatedAt).fromNow();
    }
  },
  methods: {
    selectEvent() {
      const { event_id, campaign_id } = this.listItem;
      this.$router.push({path: `/campaigns/${campaign_id}/events/${event_id}`}).catch(()=>{});;
    },
  },
};
</script>

<style lang="scss">
.campaign-event-list-item {
  cursor: pointer;

  .event-selected {
    background-color: lightyellow;
  }

  &--content {
    width: 100%;
    &-event {
      display: grid;
      grid-template-columns: 32px calc(100% - 150px) 110px;
      grid-column-gap: 4px;
      align-items: center;
      >div {
        &:nth-child(1) {
          width: 32px;
          height: 32px;
        }
        &:nth-child(2) {
          width: 100%;
          overflow: hidden;
        }
        &:nth-child(3) {
          width: 110px;
        }
      }
    }
  }
}
</style>